module.exports = __webpack_public_path__ + "img/netpeak-spider.18b7067f.svg";